import { COLORS, marginXs } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';
import { CLEAR_BUTTON_GUTTER } from 'components/ClearValueButton/ClearValueButton.styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: ${marginXs};
  position: relative;
  width: 100%;
  gap: 10rem;
  margin-bottom: 10rem;
`;

export const ChosenOptionsWrapper = styled.div`
  width: 100%;
  padding-left: 10rem;
  display: flex;
  flex-direction: column;
  gap: 10rem;
  padding-right: ${CLEAR_BUTTON_GUTTER}rem;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5rem 0;
  border-bottom: 1px solid ${COLORS.BORDER};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const LeftPart = styled.div`
  display: flex;
  gap: 10rem;
  align-items: center;
`;

export const ChosenOptionLabel = styled.label`
  color: ${COLORS.BLACK};
  font-weight: 600;
  font-size: 16rem;

  ${respondTo.smallTablet`
    font-size: 15rem;
  `}
`;

export const RightPart = styled.div`
  display: flex;
  gap: 20rem;
  align-items: center;
  padding-right: 10rem;
`;
